// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Linker */
export const Linker = createBankIcon({
  name: "Linker",
  slug: "linker",
  compe: null,
  color: "#ffffff",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#ffffff;fill-opacity:1\"\n     id=\"linker_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0154,21.0155) scale(0.02320)\">\n    <path d=\"M 2353.05,1959.95 l 0,540.05 l -985.7,0 c -146.7,0 -287.38,-56.61 -391.11,-157.35 l -667.22,-648.03 c -103.76,-100.79 -162.06,-237.47 -162.06,-380.01 L 146.96,0 l 625.66,0 l 0,1780.82 c 0,98.91 82.55,179.13 184.4,179.13 l 1396.03,0 Z\" style=\"fill:#ff6d5c\" />\n  </g>",
});
